window.__blockshopImageCartClick = false;

document.addEventListener("click", async function (e) {
  const btn = e.target.closest(".custom-image-cart-btn");
  if (!btn) return;

  // 🚨 THIS is the critical line
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  // Tell Blockshop to NOT add internally
  window.__blockshopImageCartClick = true;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    const toast = document.getElementById("add-to-cart-toast");
    if (toast) {
      toast.classList.add("show");
      setTimeout(() => toast.classList.remove("show"), 2000);
    }
  } catch (err) {
    console.error("Add to cart failed", err);
  }

  // Reset flag AFTER this click cycle
  setTimeout(() => {
    window.__blockshopImageCartClick = false;
  }, 300);
});